import React from 'react';
import '../loaders.css';

// Interior Design Themed Loading Messages
const LOADING_MESSAGES = {
  projects: [
    { text: "Curating Spaces", subtitle: "Loading our latest architectural endeavors" },
    { text: "Crafting Interiors", subtitle: "Preparing your visual journey" },
    { text: "Designing Experiences", subtitle: "Bringing spaces to life" },
    { text: "Building Dreams", subtitle: "Where functionality meets beauty" }
  ],
  general: [
    { text: "Creating Ambiance", subtitle: "Setting the perfect mood" },
    { text: "Arranging Elements", subtitle: "Every detail matters" },
    { text: "Measuring Spaces", subtitle: "Precision in design" },
    { text: "Selecting Materials", subtitle: "Quality craftsmanship ahead" }
  ],
  images: [
    { text: "Developing Images", subtitle: "Capturing design excellence" },
    { text: "Composing Views", subtitle: "Framing architectural beauty" },
    { text: "Adjusting Lighting", subtitle: "Perfecting every angle" },
    { text: "Styling Spaces", subtitle: "Attention to every detail" }
  ]
};

// Blueprint Loader - Elegant spinning circles
export const BlueprintLoader = ({ message, category = 'general' }) => {
  const messages = LOADING_MESSAGES[category];
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];
  const displayMessage = message || randomMessage;

  return (
    <div className="loading-container">
      <div className="loader-blueprint"></div>
      <div className="loading-text">{displayMessage.text}</div>
      <div className="loading-subtitle">{displayMessage.subtitle}</div>
    </div>
  );
};

// Grid Loader - Minimalist floor plan style
export const GridLoader = ({ message, category = 'general' }) => {
  const messages = LOADING_MESSAGES[category];
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];
  const displayMessage = message || randomMessage;

  return (
    <div className="loading-container">
      <div className="loader-grid">
        {[...Array(9)].map((_, i) => (
          <div key={i} className="loader-grid-item"></div>
        ))}
      </div>
      <div className="loading-text">{displayMessage.text}</div>
      <div className="loading-subtitle">{displayMessage.subtitle}</div>
    </div>
  );
};

// Lines Loader - Architectural sketching style
export const LinesLoader = ({ message, category = 'general' }) => {
  const messages = LOADING_MESSAGES[category];
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];
  const displayMessage = message || randomMessage;

  return (
    <div className="loading-container">
      <div className="loader-lines"></div>
      <div className="loading-text">{displayMessage.text}</div>
      <div className="loading-subtitle">{displayMessage.subtitle}</div>
    </div>
  );
};

// Dots Loader - Sophisticated and minimal
export const DotsLoader = ({ message, category = 'general' }) => {
  const messages = LOADING_MESSAGES[category];
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];
  const displayMessage = message || randomMessage;

  return (
    <div className="loading-container">
      <div className="loader-dots">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="loader-dot"></div>
        ))}
      </div>
      <div className="loading-text">{displayMessage.text}</div>
      <div className="loading-subtitle">{displayMessage.subtitle}</div>
    </div>
  );
};

// Project Image Loader - Specifically for project images
export const ProjectImageLoader = ({ message }) => {
  const defaultMessage = {
    text: "Loading Project",
    subtitle: "Preparing architectural showcase"
  };
  const displayMessage = message || defaultMessage;

  return (
    <div className="project-loading">
      <div className="loader-dots">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="loader-dot"></div>
        ))}
      </div>
      <div className="project-loading-text">{displayMessage.text}</div>
    </div>
  );
};

// Main Loader Component with different variants
const Loader = ({ 
  variant = 'blueprint', 
  message, 
  category = 'general',
  size = 'medium' 
}) => {
  const loaderComponents = {
    blueprint: BlueprintLoader,
    grid: GridLoader,
    lines: LinesLoader,
    dots: DotsLoader,
    project: ProjectImageLoader
  };

  const LoaderComponent = loaderComponents[variant] || BlueprintLoader;
  
  return <LoaderComponent message={message} category={category} />;
};

export default Loader;